// import ResizableBox from "../ResizableBox";
import React, {useEffect, useRef, useState} from "react";
import CanvasJSReact from '../canvasjs.react';
import DropableLabel from "./DropableLabel";
import CorrectIcon from "../images/CorrectIcon.svg"
import InCorrectIcon from "../images/incorrectIcon.svg"
import "animate.css/animate.css";
import questionsAnswers from "../containers/questionAnswers"
import supplyIcon from "../images/Supply.svg"
import SocialValue from "../images/Social-value_1.svg"
import DemandIcon from "../images/Demand.svg"
import Subsidy from "../images/Subsidy.svg"
import { Grid, Typography } from "@material-ui/core";
import styles from "./BubbleLine1Styles";
import withStyles from "@material-ui/core/styles/withStyles";
import { isMobile, isTablet } from "react-device-detect";
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

const BubbleAndLine7 = (props) => {
  const [allCorrect, setAllCorrect] =useState(false)
  const { qIndex, setCurrentScreen, classes } = props;
  const [chartData, setChartData] =useState([])
  const [submit, setSubmit] =useState(false)
  const [buyerTax, setBuyerTax] = useState(0)
  const canvasRef = useRef(null);

  // State to keep track of the selected option
  const [selectedParagraph, setSelectedParagraph] = useState("");

  // Define the letters for each option
  const optionLabels = ['a.', 'b.', 'c.'];

  let data = [
    {
      type: "line",
      color: 'transparent',
      dataPoints: []
    },
    {
      type: "spline",
      color: "#8C479B",
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 320, y: 5, cursor: 'pointer', z: 3}, {x: 300, y: 25, cursor: 'pointer', z: 3},  {x: 150, y: 175, cursor: 'pointer', z: 3}, {x: 105, y: 220, cursor: 'pointer', z: 3}]
    },
    {
      type: "spline",
      color: '#00b1d9',
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 220, y: 5, cursor: 'pointer', z: 3}, {x: 200, y: 25, cursor: 'pointer', z: 3}, {x: 125, y: 100, cursor: 'pointer', z: 3}, {x: 50, y: 175, cursor: 'pointer', z: 3}, {x: 10, y: 215, cursor: 'pointer', z: 3}]
    },
    {
      type: "spline",
      color: '#003e4c',
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 130, y: 5, cursor: 'pointer', z: 1000}, {x: 150, y: 25, cursor: 'pointer', z: 1000}, {x: 200, y: 75, cursor: 'pointer', z: 1000}, {x: 250, y: 125, cursor: 'pointer', z: 1000}, {x: 320, y: 195, cursor: 'pointer', z: 1000}]
    },
    {
      type: "scatter",
      markerSize: 15,
      color: 'green',
      dataPoints: []
    },
    {
      type: "scatter",
      markerSize: 15,
      color: 'red',
      dataPoints: []
    },
  ]

  useEffect(() => {
    setChartData(data)
  }, [])

  useEffect(() => {
    if(submit === true){
      setAllCorrect(buyerTax === 100)
    }
  },[submit])

  const options = {
    colorSet: "colorSet2",
    cursor: "pointer",
    title: {
      text: isMobile ? "" : "Supply of Snow Globes",
      fontColor: "#transparent",
      // fontColor: "#003e4c",
      fontFamily: "Rubik",
      fontWeight: "bold",
      fontSize: 24,
    },
     axisX:{
      lineColor: "#003e4c",
      lineThickness: 3,
      gridThickness: 1,
      gridColor: "#cecece",
      labelFontColor: "#003e4c",
      labelFontSize: isMobile ? 12 : 16,
      // labelFontWeight: "bold",
      labelFontFamily: "Rubik",
      interval: questionsAnswers[qIndex].step,
      minimum: 0,
      maximum: questionsAnswers[qIndex].xmax,
      labelFormatter: function(e) {
        return e.value % 2 === 0 ? e.value : "";
      }
    },
    axisY:{
      lineColor: "#003e4c",
      lineThickness: 3,
      labelFontSize: isMobile ? 12 : 16,
      labelFontFamily: "Rubik",
      gridThickness: 1,
      labelFontColor: "#003e4c",
      gridColor: "#cecece",
      interval:  questionsAnswers[qIndex].stepY,
      minimum: 0,
      maximum: questionsAnswers[qIndex].ymax,
      margin: 10
    },
    toolTip: {
      enabled: false,
    },
    data: chartData,
    height: isMobile && 200,
    width: isMobile && 320
  }

  function getButtonText() {
    if(submit){
      return allCorrect ? "Next" : "Try Again"
    }else{
      return "Submit"
    }
  }

  const clearScreen = () => {
    setSubmit(false)
    setSelectedParagraph("")
  }

  function submitButtonAction() {
    if(submit){
      if(!allCorrect){
        clearScreen()
      }
    }else{
      setSubmit(true)
    }
  }

  const getOptionBackgroundColor = (index) => {
    if(submit){
      return selectedParagraph === index ? allCorrect ? "green" : "red" : "transparent"
    }else{
      return selectedParagraph === index ? "#00b1d9" :  'transparent'
    }
  }

  return (
    <>
      <div className={classes.mainContainer}>
        <div className={classes.leftContainer4}>
          <div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column" }}>
           <div style={{ display: "flex", flexDirection: "column", width: "90%", paddingLeft: "5%", alignItems: "flex-start", paddingTop: "5%" }}>
           <h3 className={classes.questionText6}>{questionsAnswers[qIndex].question}</h3>
            <div style={{ display: "flex", flexDirection: "column", width: "95%", alignItems: "start", paddingLeft: "2%" }} className="animate__animated animate__bounceIn">

            <div style={{ display: "flex", flexDirection: "column", width: "100%", alignItems: "start", paddingLeft: "1%" }} className="animate__animated animate__bounceIn">

              <p className={classes.questionText7}>
              Using the graph, what is the per unit subsidy amount that would move the market to the socially optimal level?
              </p>
              <div style={{ display: "flex", alignItems: "center" }}>
              <button className={classes.incrementButton3} disabled={buyerTax === 0 || submit} onClick={() => setBuyerTax(buyerTax-5)}><b>-</b></button>
                <p className={classes.valueText3} style={{ color: submit ? buyerTax === 100 ? "green" : "red" : "#043e4b" }}>${buyerTax}</p>
                <button className={classes.incrementButton3} disabled={submit} onClick={() => setBuyerTax(buyerTax+5)}><b>+</b></button>
              </div>

            </div>
          </div>

            {submit && 
            <div className={classes.answerTextContainer}>
              {!allCorrect ?
                <div className={classes.incorrectAnswerContainer}>
                  <img src={InCorrectIcon} alt="InCorrectIcon" className={classes.icon}/>
                </div>
              : 
              <Grid container className={classes.correctAnswerContainer}>
                <img src={CorrectIcon} alt="CorrectIcon" className={classes.icon}/>
                <Typography className={classes.answerText}>
                A subsidy of $100, equal to the external $100 value, will move the market to the socially efficient equilibrium of Q=225.
                </Typography>
              </Grid>
              }
            </div>
            }
           </div>
          </div>
        </div>
        <div className={`animate__animated animate__bounceIn ${classes.rightContainer}`}>
          <DropableLabel
            right={'-20%'}
            marginTop={isMobile ? "10%" : "25%"}
            rotate={"rotate(270deg)"}
            label={"PRICE"}
          />
          <p className={classes.graphTitle}>{questionsAnswers[qIndex].title}</p>

          <img src={SocialValue} alt="" className={classes.socialCostIcon} />
          <img src={supplyIcon} alt="" className={classes.supplyIcon3} />

          {/* <img src={SocialValue} alt="" style={{ height: 70, width: 70, position: "absolute", zIndex: 10, right: "-12%", top: 390 }}/>
          <img src={supplyIcon} alt="" style={{ height: 70, width: 70, position: "absolute", zIndex: 10, right: "-12%", top: 130 }}/> */}
          <CanvasJSChart options = {options}  ref={canvasRef}/>
          <DropableLabel
            right={"75%"}
            marginTop={"0%"}
            rotate={"rotate(0deg)"}
            label={"QUANTITY"}
          />
          {allCorrect &&
            <img src={Subsidy} alt="" className={classes.taxIcon} />
          }
          <img src={DemandIcon} alt="" className={classes.demandIcon} />
          {/* <img src={DemandIcon} alt="" style={{ height: 80, width: 80, position: "absolute", zIndex: 10, right: "12%", top: 390 }}/> */}
          {/* {submit && (getLabeltext() || getAnswertext()) &&
            <div style={{ display: "flex", top: 0, height: "78%", width: "100%", position: "absolute", zIndex: 1, background: "rgba(152, 152, 152, 0.5)" }}>
            </div>
          } */}
          <div className={classes.buttonContainer6}>
            {
            getButtonText() !== 'Next' ? (<>
              <button className={classes.buttonSubmit6} onClick={() => submitButtonAction()}>{getButtonText()}</button>
              <button className={classes.clearButton6} onClick={() => clearScreen()}>Clear</button>
              </>) : <button className={classes.nextButton6} onClick={() => setCurrentScreen("Result")}>{getButtonText()}</button>
            }
          </div>
        </div>
      </div>
    </>
  )

}
export default withStyles(styles)(BubbleAndLine7);
